// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__34lGX","content":"LayoutSettings_content__2ZS9j"};